import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import da from './da.json'

const FALLBACK_LANG = 'en'
const DEFAULT_LANG = 'da'

const resources = {
  da: {
    translation: da
  }
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: FALLBACK_LANG,
    lng: getLanguage(),
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  })

export default i18n

/**
 * Store the language in local storage
 *
 * @param lang Language to set
 */
export function setLanguage(lang: string) {
  window.localStorage.setItem('lang', lang)
}

/**
 * Get the language from local storage, if nothing is defined, it returns the
 * default language.
 *
 * @returns Stored language
 */
export function getLanguage() {
  return window.localStorage.getItem('lang') || DEFAULT_LANG
}
